import { FC, useState } from 'react';
import styles from './TruncatedText.module.css';

type TruncatedTextProps = {
  text: string;
  maxLength?: number;
  letReadMore?: boolean;
  showFullOnHover?: boolean;
  className?: string;
};

const TruncatedText: FC<TruncatedTextProps> = ({ text, maxLength = 100, letReadMore = false, showFullOnHover = true, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (text.length <= maxLength) {
    return <p className={className ? className : ''}>{text}</p>;
  }

  return (
    <p
      className={`${styles.truncatedText} ${showFullOnHover ? styles.hoverLabel : ''} ${className ? className : ''}`}
      {...(showFullOnHover && { 'data-label': text })} // Use data-label for custom styling
    >
      {isExpanded ? text : `${text.slice(0, maxLength)}...`}
      {letReadMore && (
        <button onClick={() => setIsExpanded(!isExpanded)} className={styles.readMoreButton}>
          {isExpanded ? 'Read Less' : 'Read More'}
        </button>
      )}
    </p>
  );
};

export default TruncatedText;